import { Location, LocationType } from '../../../../../@posturinn/client-react';
import { IPostBox } from '../../../../../constants/data/postBoxes';
import { ReactComponent as IconBox } from '../../../../../icons/box.svg';
import { ReactComponent as IconCar } from '../../../../../icons/car.svg';
import { ReactComponent as IconPakkaport } from '../../../../../icons/delivery_option_pakkaport.svg';
import { ReactComponent as IconPostoffice } from '../../../../../icons/delivery_option_postoffice.svg';
import { ReactComponent as IconHouse } from '../../../../../icons/department.svg';
import { ReactComponent as IconGrid } from '../../../../../icons/grid.svg';
import { ReactComponent as IconParcel } from '../../../../../icons/parcel.svg';
import { ReactComponent as IconMailOpen } from '../../../../../icons/tags.svg';

export const getIconByServiceCode = (code: string) => {
	switch (code) {
		case 'PostOffice': {
			return IconPostoffice;
		}
		case 'ParcelPoint': {
			return IconPakkaport;
		}
		case 'Postbox': {
			return IconGrid;
		}
		case 'DPH': {
			return IconCar;
		}
		case 'DPP': {
			return IconPostoffice;
		}
		case 'DPO': {
			return IconGrid;
		}
		case 'DPT': {
			return IconPakkaport;
		}
		case 'DRA': {
			return IconMailOpen;
		}
		case 'DRP': {
			return IconMailOpen;
		}
		case 'DRR': {
			return IconMailOpen;
		}
		case 'DXO': {
			return IconGrid;
		}
		case 'DXP': {
			return IconHouse;
		}
		case 'DXA': {
			return IconCar;
		}
		case 'OPA': {
			return IconParcel;
		}
		case 'OPB': {
			return IconBox;
		}
		case 'ORR': {
			return IconMailOpen;
		}
		default: {
			return IconCar;
		}
	}
};

export const getPostboxesSelectOptions = (postboxes: IPostBox[]) => {
	return postboxes.map(postbox => ({
		value: postbox.id,
		label: postbox.name,
	}));
};

export const getLocationsSelectOptions = (locations, locationType: LocationType) => {
	const locationsByType = [];
	locations &&
		locations.map(location =>
			location && location.locationType === locationType ? locationsByType.push(location) : ''
		);

	return locationsByType.map((location: Location) => ({
		value: location.id,
		label: `${location.name}, ${location.address.street1}, ${location.address.postalCode} ${location.address.city}`,
	}));
};
